export default __webpack_public_path__ + "static/media/whatsapp.c83e58eb.svg";